var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeviceStatusUnlinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_unassociated",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.001,
    height: 15.001,
    viewBox: "0 0 15.001 15.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-unlinked-device-status-icon {\n        fill: #77859f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_13",
    "data-name": "Subtraction 13",
    className: "cls-unlinked-device-status-icon",
    d: "M-8521.5,15a7.508,7.508,0,0,1-7.5-7.5,7.508,7.508,0,0,1,7.5-7.5,7.509,7.509,0,0,1,7.5,7.5A7.509,7.509,0,0,1-8521.5,15Zm-1.7-7.712v.6h.946l3.913,3.913.426-.426-7.46-7.462-.426.428,1.4,1.4a1.882,1.882,0,0,0-.79.587,1.951,1.951,0,0,0-.443,1.261,1.926,1.926,0,0,0,.582,1.406,1.922,1.922,0,0,0,1.4.582h1.691v-.6h-1.691a1.344,1.344,0,0,1-.982-.407,1.348,1.348,0,0,1-.406-.985,1.346,1.346,0,0,1,.406-.982,1.35,1.35,0,0,1,.713-.383l1.065,1.068Zm1.988-1.659v.6h1.539a1.336,1.336,0,0,1,.985.407,1.346,1.346,0,0,1,.406.982,1.284,1.284,0,0,1-.338.884,1.485,1.485,0,0,1-.846.477l.488.488a2.145,2.145,0,0,0,.933-.736,1.858,1.858,0,0,0,.357-1.113,1.921,1.921,0,0,0-.58-1.4,1.922,1.922,0,0,0-1.406-.582Zm.088,1.689h0l.6.6h.406v-.6h-1Z",
    transform: "translate(8529.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceStatusUnlinked);
export default __webpack_public_path__ + "static/media/icon-device-status-unlinked.94d449b2eaf60c9b6c6df6ca0a7f6bbe.svg";
export { ForwardRef as ReactComponent };